import { useTranslation } from 'react-i18next';

import {
	useGoogleMyBusinessTemplateQuery,
	useMutationEditGoogleMyBusiness,
} from '@adflow/frontend/feat-google-my-business';
import { theme } from '@adflow/frontend/ui-theme';
import { useQueryStatusUI } from '@adflow/frontend/util-query';

import { GMBTemplateFormView } from './GMBTemplateFormView';

export function GMBTemplateFormEdit({ templateId }: { templateId: number }) {
	const { t } = useTranslation('facebook');

	const templateQuery = useGoogleMyBusinessTemplateQuery(templateId);
	const editTemplate = useMutationEditGoogleMyBusiness();

	const queryStatusIndicator = useQueryStatusUI([templateQuery], {
		errorMessage: t('error.loadingTemplate'),
		showNotFoundIndicator: true,
		notFoundError: t('error.templateNotFound'),
		containerStyle: {
			backgroundColor: theme.colors.background.form,
		},
	});

	if (queryStatusIndicator !== null || templateQuery.data === undefined) {
		return queryStatusIndicator;
	}

	return (
		<GMBTemplateFormView
			key={JSON.stringify(templateQuery.data)}
			title={t('editTemplate')}
			template={templateQuery.data}
			onSubmit={async (values) =>
				await editTemplate.mutateAsync({
					templateId,
					body: values,
				})
			}
		/>
	);
}
